import React from 'react';
import { CheckIcon } from 'lucide-react';
import { processSteps } from '../data/reviews';
import { images } from '../data/site';
const promises = ['On-time arrival, every time', 'Written, fixed-price quotes', 'Clean job site when we leave', 'Professional quality-assurance guarantee'];
export function About() {
  return <section id="about" className="bg-canvas py-20 lg:py-28" data-id="element-1" data-mp="2ytq7hp205ynh">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-8" data-id="element-2" data-mp="33rrps7rlttxw">
        <div className="relative" data-id="element-3" data-mp="38pjeyu0v71ye">
          <img src={images.team} alt="The Home Repair MD team in front of their work van in Las Vegas" className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-4" data-mp="38oi52svl4li9" />
          <div className="absolute -bottom-6 left-6 right-6 rounded-xl bg-brand p-5 text-white shadow-xl sm:left-auto sm:w-72" data-id="element-5" data-mp="3hkr2k2005a1r">
            <p className="font-display text-3xl font-extrabold leading-none" data-id="element-6" data-mp="3rgko2avp8dvo">Born & raised in Vegas</p>
            <p className="mt-1.5 text-sm text-white/85" data-id="element-7" data-mp="2lqz60fpwv2sa">Fixing homes across the valley we call home.</p>
          </div>
        </div>

        <div className="pt-6 lg:pt-0" data-id="element-8" data-mp="2grcqfzmm1agb">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-9" data-mp="2guh21i2en8h0">
            Why Las Vegas trusts <span className="text-brand" data-id="element-10" data-mp="27rzdgwza23qu">Home Repair MD</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ink-muted" data-id="element-11" data-mp="34hp6xyvx8fii">
            We’re a local, family-owned business with many years of construction experience. We started our own
            company because we love what we do — and our love for our hometown drives us to bring quality, affordable
            home maintenance and repair to the Las Vegas Valley.
          </p>
          <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-12" data-mp="2qo7o6gb276tj">
            {promises.map(p => <li key={p} className="flex items-start gap-2.5 font-semibold text-ink" data-id="element-13" data-mp="3o70r6k6iwtzi">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-14" data-mp="3jdenvim922gd" />
                {p}
              </li>)}
          </ul>

          <h3 className="mt-12 font-display text-2xl font-bold uppercase text-ink" data-id="element-15" data-mp="b3viz8w4cpv3">How it works</h3>
          <ol className="mt-5 space-y-0" data-id="element-16" data-mp="3thv2k8nztdil">
            {processSteps.map((s, i) => <li key={s.title} className="relative flex gap-5 pb-7 last:pb-0" data-id="element-17" data-mp="1ebxdvh0uhwj" data-mpi={i}>
                {i < processSteps.length - 1 && <span className="absolute left-5 top-11 h-[calc(100%-2.75rem)] w-px bg-line" aria-hidden="true" data-id="element-18" data-mp="3jj5jickd1n0r" />}
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ink font-display text-xl font-bold text-white" data-id="element-19" data-mp="3ak1xazpwcri1">
                  {i + 1}
                </span>
                <div data-id="element-20" data-mp="3engp0nn76wbb">
                  <p className="font-display text-xl font-bold text-ink" data-id="element-21" data-mp="18syma9c3hawy">{s.title}</p>
                  <p className="mt-1 text-ink-muted" data-id="element-22" data-mp="1cuabweuyxw55">{s.text}</p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}